<template>
    <div class="title item main_title_icon">
      <slot>
            
      </slot>
    </div>
</template>

<script setup>

</script>

<style scoped>

.main_title_icon {
  width: 100% ;
  margin: 0 auto ;
}

.main_title_icon h2 {
  display: inline-block;
    font-size: 18px;
    margin: 0;
    color: #414951;
    font-weight: 600;

}

.main_title_icon svg {
  width: 16px;
  height: 18px;
  margin-right: 10px;
  margin-left: 1px;
  fill: #28bc6d;
  margin-top: -5px;
  
}


</style>